export const getCommaSeparatedValues = (arr: any[]) => {
    if (!arr || arr.length === 0) {
        return;
    }
    const str = arr.filter(val => val !== null && val !== "").join(", ");
    return str;
};

export const getQueryParameterFromUri = (uri: string | undefined, parameterName: string) => {
    let queryParameter = "";
    if (uri) {
        const queryParams = uri.split("?")[1];
        const urlParams = new URLSearchParams(queryParams);
        queryParameter = urlParams.get(parameterName) || "";
    }
    return queryParameter;
};

export const formatPhone = (value: string): string => {
    // Receives phone number as 9988776655 or a partial one like 99439
    // Output - 998-877-6655
    if (!value) {
        return "";
    }
    value = value.split("-").join("");
    const length = value.length;
    if (length <= 3) {
        return value;
    }
    let modifiedValue = "";
    if (length >= 4 && length <= 6) {
        modifiedValue = `${value.substring(0, 3)}-${value.substring(3)}`;
    } else if (length > 6) {
        modifiedValue = `${value.substring(0, 3)}-${value.substring(3, 6)}-${value.substring(6)}`;
    }
    return modifiedValue;
};

export function convertDateToDateString(date: Date | undefined) {
    // return date in "dd-MMM-yyyy"
    if (!date) {
        return "";
    }
    const month = date.toLocaleString('default', { month: 'short' });
    const day = date.getDate();
    const dateString = day < 10 ? `0${day}` : day;

    return `${dateString}-${month}-${date.getFullYear()}`;
}

export const generateQueryString = (obj: { [key: string]: any }) => {
    // generates a query string from sn Object
    const data: { [key: string]: any } = {};
    for (const key in obj) {
        if (obj[key]) {
            data[key] = obj[key];
        }
    }
    const queryParams = new URLSearchParams(data);
    return queryParams.toString();
};

export const isExpiryDatePassed = (expiryDate: Date, currentDate: Date) => {
    // Set the time of both dates to midnight to ignore time
    expiryDate.setHours(0, 0, 0, 0);
    currentDate.setHours(0, 0, 0, 0);
    // Compare the dates in miliseconds
    return expiryDate.getTime() < currentDate.getTime();
};